const email1 = {
  id: 1,
  passage: `Dear Alex Morgan,

We hope this message finds you well. We wanted to inform you that the <mark>recruitment</mark> process for the position of Senior Product Manager has concluded. We <mark>sincerely</mark> appreciate your efforts and collaboration <mark>throughout</mark> the process.

Here are the details of the position closure:

- Position Title: Senior Product Manager
- Company Name: Nexora Technologies
- Department: Product Development
- Date of Closure: August 20, 2055

We are <mark>grateful</mark> for your support and the quality <mark>candidates</mark> you provided. While this <mark>particular</mark> role has closed, we look forward to <mark>partnering</mark> with you for future opportunities.

If you have any questions or require further information, please do not hesitate to reach out.

Thank you once again for your collaboration.

Best regards,

Rachel Kim

Talent Acquisition Lead

Nexora Technologies`,

  translation: `알렉스 모건님께,

안녕하세요. 시니어 제품 관리자 직책에 대한 채용 과정이 마무리되었음을 알려드립니다. 전체 과정에서 보여주신 노력과 협조에 진심으로 감사드립니다.

다음은 직책 마감에 대한 세부 정보입니다:

- 직책명: 시니어 제품 관리자
- 회사명: 넥소라 테크놀로지스
- 부서: 제품 개발
- 마감일: 2055년 8월 20일

귀하의 지원과 제공해 주신 우수한 후보자들에 감사드립니다. 이 특정 역할은 마감되었지만, 향후 기회에도 함께 협력하기를 기대합니다.

질문이나 추가 정보가 필요하시면 언제든지 연락 주시기 바랍니다.

다시 한번 협력에 감사드립니다.

감사합니다,

레이첼 김

인재 채용 책임자

넥소라 테크놀로지스`,

  koreanNouns: `Dear Alex Morgan,

We hope this message finds you well. We wanted to inform you that the <mark>채용</mark> process for the position of Senior Product Manager has concluded. We <mark>진심으로</mark> appreciate your efforts and collaboration <mark>전체</mark> the process.

Here are the details of the position closure:

- Position Title: Senior Product Manager
- Company Name: Nexora Technologies
- Department: Product Development
- Date of Closure: August 20, 2055

We are <mark>감사하는</mark> for your support and the quality <mark>후보자들</mark> you provided. While this <mark>특정</mark> role has closed, we look forward to <mark>협력하는것</mark> with you for future opportunities.

If you have any questions or require further information, please do not hesitate to reach out.

Thank you once again for your collaboration.

Best regards,

Rachel Kim

Talent Acquisition Lead

Nexora Technologies`,

  wordPairs: {
    recruitment: "채용",
    sincerely: "진심으로",
    throughout: "전체",
    grateful: "감사하는",
    candidates: "후보자들",
    particular: "특정",
    partnering: "협력하는것",
  },

  questions: [],
};
const email2 = {
  id: 2,
  passage: `Dear Sophie Lee,

I hope this message finds you well. I am writing to inform you that we need to <mark>adjust</mark> the schedule for your <mark>upcoming</mark> interview with Orion Labs. We understand the importance of this opportunity for you and <mark>are committed to</mark> ensuring that the process is as <mark>smooth</mark> and convenient as possible.

<mark>Below</mark> are the updated details for your interview:

- Position: UX Designer
- Interviewer: Daniel Kim, Head of Product Design
- New Date: August 22, 2055
- New Time: 2:30 PM – 3:15 PM (PST)
- Format: Virtual (link will be sent 24 hours prior)

Please confirm your availability for the rescheduled interview. If you have any conflicts with this new <mark>timing</mark>, do not hesitate to reach out to me, and we will do our best to <mark>accommodate</mark> your schedule.

Thank you for your understanding and <mark>flexibility</mark>. We look forward to <mark>facilitating</mark> this interview and are excited about the possibility of you joining the team at Orion Labs.

Best regards,

Maya Johnson

Recruiting Coordinator`,

  translation: `소피 리님께,

안녕하세요. 오리온 랩스와의 예정된 면접 일정을 조정해야 함을 알려드리고자 합니다. 저희는 이 기회가 귀하에게 중요하다는 것을 이해하며, 과정이 최대한 원활하고 편리하게 진행되도록 최선을 다하고 있습니다.

다음은 면접에 대한 업데이트된 세부 정보입니다:

- 직책: UX 디자이너
- 면접관: 다니엘 김, 제품 디자인 책임자
- 새 날짜: 2055년 8월 22일
- 새 시간: 오후 2:30 – 3:15 (PST)
- 형식: 가상 (링크는 24시간 전에 발송됩니다)

재조정된 면접 일정에 대한 귀하의 가능 여부를 확인해 주시기 바랍니다. 새로운 일정에 충돌이 있으시면 주저하지 마시고 저에게 연락해 주시면, 귀하의 일정에 맞게 최선을 다해 조정하겠습니다.

이해와 유연성에 감사드립니다. 이 면접을 진행하게 되어 기쁘며, 귀하가 오리온 랩스 팀에 합류할 가능성에 대해 기대하고 있습니다.

감사합니다,

마야 존슨

채용 코디네이터`,

  koreanNouns: `Dear Sophie Lee,

I hope this message finds you well. I am writing to inform you that we need to <mark>조정하다</mark> the schedule for your <mark>예정된</mark> interview with Orion Labs. We understand the importance of this opportunity for you and <mark>최선을 다하고 있습니다</mark> ensuring that the process is as <mark>원활한</mark> and convenient as possible.

<mark>아래는</mark> are the updated details for your interview:

- Position: UX Designer
- Interviewer: Daniel Kim, Head of Product Design
- New Date: August 22, 2055
- New Time: 2:30 PM – 3:15 PM (PST)
- Format: Virtual (link will be sent 24 hours prior)

Please confirm your availability for the rescheduled interview. If you have any conflicts with this new <mark>일정</mark>, do not hesitate to reach out to me, and we will do our best to <mark>맞게 조정하다</mark> your schedule.

Thank you for your understanding and <mark>유연성</mark>. We look forward to <mark>진행하는것</mark> this interview and are excited about the possibility of you joining the team at Orion Labs.

Best regards,

Maya Johnson

Recruiting Coordinator`,

  wordPairs: {
    adjust: "조정하다",
    upcoming: "예정된",
    "are committed to": "최선을 다하고 있습니다",
    smooth: "원활한",
    Below: "아래는",
    timing: "일정",
    accommodate: "맞게 조정하다",
    flexibility: "유연성",
    facilitating: "진행하는것",
  },

  questions: [],
};
const email3 = {
  id: 3,
  passage: `Dear Alex Kim,

I hope this message finds you well. My name is Rachel Lee, a professional recruiter with Vertex Search Partners. I am reaching out to <mark>present</mark> you with an <mark>exciting</mark> career opportunity that <mark>aligns with</mark> your <mark>remarkable</mark> skills and experience.

We are currently looking for a talented individual to fill the position of Senior Marketing Manager at BrightEdge Global, a leader in the consumer technology sector.

Position Details:

Job Title: Senior Marketing Manager
Location: San Francisco, CA (Hybrid)
Salary Range: $130,000 – $150,000 <mark>annually</mark> + <mark>performance bonuses</mark>
Starting Date: October 1, 2055

Key Responsibilities:

Lead and <mark>oversee</mark> multi-channel marketing campaigns.
Develop and implement strategies for brand positioning and audience engagement.
Collaborate with the team to analyze performance <mark>metrics</mark> and optimize campaign effectiveness.
Ensure seamless operations in <mark>cross-functional</mark> marketing initiatives and <mark>vendor</mark> coordination.

Candidate Requirements:

Proven experience in leading strategic marketing initiatives in the tech or SaaS industry.
Strong skills in digital marketing and data-driven analysis.
Excellent leadership and communication skills.
Experience working in fast-paced, high-growth environments.


Joining BrightEdge Global will provide you with <mark>unparalleled</mark> opportunities to grow and <mark>succeed in</mark> your field. If this sounds like the perfect fit for you, I would be thrilled to discuss this opportunity further with you.

Please let me know a convenient time for us to connect, or feel free to reach out to me <mark>directly</mark> at (213) 555-4098 or rachel.lee@vertexsearch.com. Additionally, if you know of someone in your network who might be an excellent fit for this role, I would appreciate your <mark>referral</mark>.

Thank you for considering this opportunity. I look forward to the possibility of working together.

Best regards,
Rachel Lee
Executive Recruiter
Vertex Search Partners`,

  translation: `김알렉스님께,

안녕하세요. 저는 버텍스 서치 파트너스의 전문 채용 담당자 레이첼 리입니다. 귀하의 뛰어난 기술과 경험에 부합하는 흥미로운 경력 기회를 소개해 드리고자 연락드립니다.

현재 저희는 소비자 기술 분야의 선두 기업인 브라이트엣지 글로벌에서 시니어 마케팅 매니저 직책을 맡을 재능 있는 인재를 찾고 있습니다.

직무 세부 정보:
직책: 시니어 마케팅 매니저

근무지: 샌프란시스코, CA (하이브리드)

급여 범위: 연봉 $130,000 – $150,000 + 성과 보너스

시작일: 2055년 10월 1일

주요 책임:
다중 채널 마케팅 캠페인 주도 및 감독.

브랜드 포지셔닝 및 고객 참여를 위한 전략 개발 및 구현.

팀과 협력하여 성과 지표를 분석하고 캠페인 효과를 최적화.

부서 간 마케팅 이니셔티브 및 벤더 조정에서 원활한 운영 보장.

지원자 요건:
기술 또는 SaaS 산업에서 전략적 마케팅 이니셔티브를 이끈 입증된 경험.

디지털 마케팅 및 데이터 기반 분석에 대한 강한 기술.

우수한 리더십 및 커뮤니케이션 능력.

빠른 속도의 고성장 환경에서 일한 경험.


브라이트엣지 글로벌에 합류하면 귀하의 분야에서 성장하고 성공할 수 있는 비교할 수 없는 기회를 제공받게 됩니다. 이것이 귀하에게 완벽한 기회라고 생각되신다면, 이 기회에 대해 더 자세히 논의하게 되어 기쁠 것입니다.

편하신 시간에 연락 가능한 시간을 알려주시거나, (213) 555-4098 또는 rachel.lee@vertexsearch.com으로 직접 연락주시기 바랍니다. 또한, 이 역할에 적합할 수 있는 귀하의 네트워크에 있는 분을 알고 계시다면, 추천해 주시면 감사하겠습니다.

이 기회를 고려해 주셔서 감사합니다. 함께 일할 수 있는 가능성을 기대합니다.

감사합니다,
레이첼 리
전문 채용 담당자
버텍스 서치 파트너스`,

  koreanNouns: `Dear Alex Kim,

I hope this message finds you well. My name is Rachel Lee, a professional recruiter with Vertex Search Partners. I am reaching out to <mark>제시하다</mark> you with an <mark>흥미로운</mark> career opportunity that <mark>부합하는</mark> your <mark>뛰어난</mark> skills and experience.

We are currently looking for a talented individual to fill the position of Senior Marketing Manager at BrightEdge Global, a leader in the consumer technology sector.

Position Details:

Job Title: Senior Marketing Manager
Location: San Francisco, CA (Hybrid)
Salary Range: $130,000 – $150,000 <mark>연간으로</mark> + <mark>성과 보너스</mark>
Starting Date: October 1, 2055

Key Responsibilities:

Lead and <mark>감독하다</mark> multi-channel marketing campaigns.
Develop and implement strategies for brand positioning and audience engagement.
Collaborate with the team to analyze performance <mark>지표</mark> and optimize campaign effectiveness.
Ensure seamless operations in <mark>부서 간</mark> marketing initiatives and <mark>외주업체</mark> coordination.

Candidate Requirements:

Proven experience in leading strategic marketing initiatives in the tech or SaaS industry.
Strong skills in digital marketing and data-driven analysis.
Excellent leadership and communication skills.
Experience working in fast-paced, high-growth environments.


Joining BrightEdge Global will provide you with <mark>비교할 수 없는</mark> opportunities to grow and <mark>성공하다 -에서</mark> your field. If this sounds like the perfect fit for you, I would be thrilled to discuss this opportunity further with you.

Please let me know a convenient time for us to connect, or feel free to reach out to me <mark>직접</mark> at (213) 555-4098 or rachel.lee@vertexsearch.com. Additionally, if you know of someone in your network who might be an excellent fit for this role, I would appreciate your <mark>추천</mark>.

Thank you for considering this opportunity. I look forward to the possibility of working together.

Best regards,
Rachel Lee
Executive Recruiter
Vertex Search Partners`,

  wordPairs: {
    present: "제시하다",
    exciting: "흥미로운",
    "aligns with": "부합하는",
    remarkable: "뛰어난",
    annually: "연간으로",
    "performance bonuses": "성과 보너스",
    oversee: "감독하다",
    metrics: "지표",
    vendor: "외주업체",
    "cross-functional": "부서 간",
    unparalleled: "비교할 수 없는",
    "succeed in": "성공하다 -에서",
    directly: "직접",
    referral: "추천",
  },

  questions: [],
};
const email4 = {
  id: 4,
  passage: `Dear Dr. Emily Chen,

I hope this message finds you well. My name is Liam Park, and I am a Content Editor at MindShift Media. We are an organization <mark>dedicated to</mark> creating <mark>thought-provoking</mark> and socially impactful content, and we believe your <mark>expertise</mark> and experience will provide valuable insights for our audience.

We are currently working on a feature article that focuses on the future of mental health support in digital spaces, and we believe your <mark>contributions</mark> would be incredibly impactful given your background in clinical psychology and digital therapy innovation.

We would be <mark>honored</mark> to have the opportunity to interview you at your convenience. The interview would take <mark>approximately</mark> 30–45 minutes and can be conducted via Zoom or phone, depending on your preference.

Here are the <mark>potential</mark> dates and times for the interview:

- Tuesday, August 22 at 11:00 AM (PST)
- Wednesday, August 23 at 2:30 PM (PST)
- Friday, August 25 at 10:00 AM (PST)

Please let us know if any of these options are <mark>suitable</mark> for you or if there is another time that works better with your schedule.

Thank you for considering our request. We are looking forward to the possibility of working together and learning from your valuable insights. Please feel free to reach out to me if you have any questions or need further information.

Warm regards,

Liam Park

Content Editor

MindShift Media`,

  translation: `친애하는 Emily Chen 박사님께,

안녕하세요. 저는 MindShift Media의 콘텐츠 에디터 Liam Park입니다. 저희는 생각을 자극하고 사회적으로 영향력 있는 콘텐츠를 만드는 데 전념하는 조직이며, 박사님의 전문 지식과 경험이 저희 독자들에게 귀중한 통찰력을 제공할 것이라고 믿습니다.

저희는 현재 디지털 공간에서의 정신 건강 지원의 미래에 초점을 맞춘 특집 기사를 작업 중이며, 박사님의 임상 심리학 및 디지털 치료 혁신 분야의 배경을 고려할 때 박사님의 기여가 믿을 수 없을 정도로 영향력이 있을 것이라고 생각합니다.

박사님의 편의에 맞춰 인터뷰할 기회를 갖게 되어 영광입니다. 인터뷰는 약 30-45분 정도 소요되며, 박사님의 선호도에 따라 Zoom 또는 전화로 진행될 수 있습니다.

다음은 인터뷰 가능한 날짜와 시간입니다:

- 8월 22일 화요일 오전 11시 (PST)
- 8월 23일 수요일 오후 2시 30분 (PST)
- 8월 25일 금요일 오전 10시 (PST)

이 옵션 중 적합한 것이 있는지 또는 박사님의 일정에 더 잘 맞는 다른 시간이 있는지 알려주시기 바랍니다.

저희 요청을 고려해 주셔서 감사합니다. 함께 일하고 박사님의 귀중한 통찰력을 배울 수 있는 가능성을 기대하고 있습니다. 질문이 있거나 추가 정보가 필요하시면 언제든지 저에게 연락해 주십시오.

따뜻한 인사를 보내며,

Liam Park

콘텐츠 에디터

MindShift Media`,

  koreanNouns: `Dear Dr. Emily Chen,

I hope this message finds you well. My name is Liam Park, and I am a Content Editor at MindShift Media. We are an organization <mark>전념하는 -에</mark> creating <mark>생각을 자극하고</mark> and socially impactful content, and we believe your <mark>전문 지식</mark> and experience will provide valuable insights for our audience.

We are currently working on a feature article that focuses on the future of mental health support in digital spaces, and we believe your <mark>기여</mark> would be incredibly impactful given your background in clinical psychology and digital therapy innovation.

We would be <mark>영광스러운</mark> to have the opportunity to interview you at your convenience. The interview would take <mark>약</mark> 30–45 minutes and can be conducted via Zoom or phone, depending on your preference.

Here are the <mark>가능한</mark> dates and times for the interview:

- Tuesday, August 22 at 11:00 AM (PST)
- Wednesday, August 23 at 2:30 PM (PST)
- Friday, August 25 at 10:00 AM (PST)

Please let us know if any of these options are <mark>적합한</mark> for you or if there is another time that works better with your schedule.

Thank you for considering our request. We are looking forward to the possibility of working together and learning from your valuable insights. Please feel free to reach out to me if you have any questions or need further information.

Warm regards,

Liam Park

Content Editor

MindShift Media`,

  wordPairs: {
    "dedicated to": "전념하는 -에",
    "thought-provoking": "생각을 자극하고",
    expertise: "전문 지식",
    contributions: "기여",
    honored: "영광스러운",
    approximately: "약",
    potential: "가능한",
    suitable: "적합한",
  },

  questions: [],
};

const email5 = {
  id: 5,
  passage: `Dear Daniel Cho,

I hope this message finds you well. My name is Rachel Kim, and I am a <mark>representative</mark> from TalentBridge Partners. We have been very impressed with your skills and experience, and we are looking forward to moving forward with the interview process with Lumos Technology Group.

As part of the next steps, we would like to discuss and negotiate your <mark>annual salary</mark>. It is important for us to ensure that both you and Lumos Technology Group find a <mark>mutually</mark> beneficial agreement.

In order to <mark>facilitate</mark> this process, please consider the following key points:

- Current Salary Range: $95,000 – $110,000 (based on experience and qualifications)
- Industry Standards: The industry average for similar roles in the software engineering sector in your region typically falls between $92,000 and $115,000.
- Additional Benefits: <mark>Comprehensive</mark> health insurance, 401(k) matching program, annual performance bonus, <mark>remote work flexibility</mark>, and professional development <mark>allowances</mark>.

Please let us know your salary expectations and any other factors you would like us to <mark>take into account</mark>. We are committed to ensuring a fair and <mark>transparent</mark> negotiation process.

We look forward to your response and moving forward in the best interest of all parties involved.

Best regards,

Rachel Kim

Senior Recruitment Consultant

TalentBridge Partners`,

  translation: `친애하는 Daniel Cho님,

안녕하세요. 저는 TalentBridge Partners의 담당자 Rachel Kim입니다. 저희는 귀하의 기술과 경험에 매우 감명받았으며, Lumos Technology Group와의 면접 과정을 진행하게 되어 기대하고 있습니다.

다음 단계로, 저희는 귀하의 연봉에 대해 논의하고 협상하고자 합니다. 귀하와 Lumos Technology Group 모두에게 상호 이익이 되는 합의점을 찾는 것이 중요합니다.

이 과정을 원활히 진행하기 위해 다음 주요 사항을 고려해 주시기 바랍니다:

- 현재 급여 범위: $95,000 – $110,000 (경험 및 자격에 따라)
- 업계 표준: 귀하 지역의 소프트웨어 엔지니어링 분야에서 유사한 역할의 업계 평균은 일반적으로 $92,000에서 $115,000 사이입니다.
- 추가 혜택: 종합 건강 보험, 401(k) 매칭 프로그램, 연간 성과 보너스, 원격 근무 유연성 및 전문 개발 수당.

귀하의 급여 기대치와 저희가 고려해야 할 다른 요소들을 알려주시기 바랍니다. 저희는 공정하고 투명한 협상 과정을 보장하기 위해 최선을 다하고 있습니다.

귀하의 답변을 기다리며, 모든 관련 당사자들의 최선의 이익을 위해 앞으로 나아가기를 기대합니다.

감사합니다,

Rachel Kim

수석 채용 컨설턴트

TalentBridge Partners`,

  koreanNouns: `Dear Daniel Cho,

I hope this message finds you well. My name is Rachel Kim, and I am a <mark>담당자</mark> from TalentBridge Partners. We have been very impressed with your skills and experience, and we are looking forward to moving forward with the interview process with Lumos Technology Group.

As part of the next steps, we would like to discuss and negotiate your <mark>연봉</mark>. It is important for us to ensure that both you and Lumos Technology Group find a <mark>상호</mark> beneficial agreement.

In order to <mark>진행하하다</mark> this process, please consider the following key points:

- Current Salary Range: $95,000 – $110,000 (based on experience and qualifications)
- Industry Standards: The industry average for similar roles in the software engineering sector in your region typically falls between $92,000 and $115,000.
- Additional Benefits: <mark>종합적인</mark> health insurance, 401(k) matching program, annual performance bonus, <mark>원격 근무 유연성</mark>, and professional development <mark>수당</mark>.

Please let us know your salary expectations and any other factors you would like us to <mark>고려하다</mark>. We are committed to ensuring a fair and <mark>투명한</mark> negotiation process.

We look forward to your response and moving forward in the best interest of all parties involved.

Best regards,

Rachel Kim

Senior Recruitment Consultant

TalentBridge Partners`,

  wordPairs: {
    representative: "담당자",
    "annual salary": "연봉",
    mutually: "상호",
    facilitate: "진행하하다",
    comprehensive: "종합적인",
    "remote work flexibility": "원격 근무 유연성",
    allowances: "수당",
    "take into account": "고려하다",
    transparent: "투명한",
  },

  questions: [],
};
const email6 = {
  id: 6,
  passage: `Dear Hannah Lee,

We are thrilled to inform you that you have been selected for the position of Marketing Specialist at NovaBridge Solutions. Our team was <mark>highly</mark> impressed with your qualifications and experience, and we are confident that you will be a valuable addition to our organization.

Please find below the details of the offer:

- Position: Marketing Specialist
- Salary: $68,000 per year + performance-based bonus
- Start Date: September 4, 2055
- Location: 1200 Grand Avenue, Suite 402, San Francisco, CA

We would like to invite you to a <mark>meeting</mark> to discuss the details of your employment <mark>in person</mark>. During this meeting, we can <mark>address</mark> any questions or concerns you might have. Please let us know your availability for the upcoming week.

Thank you for considering our offer. We are eager to <mark>welcome you aboard</mark> and look forward to working together to achieve great success.

Best Regards,

Jordan Park
HR Manager
NovaBridge Solutions`,

  translation: `한나 이님께,

저희는 귀하께서 노바브릿지 솔루션즈의 마케팅 전문가 직책에 선발되었음을 알려드리게 되어 기쁩니다. 저희 팀은 귀하의 자격과 경험에 깊은 인상을 받았으며, 귀하께서 저희 조직에 가치 있는 인재가 될 것이라 확신합니다.

아래에 제안 세부 사항을 확인해 주십시오:

- 직책: 마케팅 전문가
- 급여: 연 $68,000 + 성과 기반 보너스
- 시작일: 2055년 9월 4일
- 위치: 1200 Grand Avenue, Suite 402, San Francisco, CA

저희는 귀하를 직접 만나 고용 세부 사항에 대해 논의하는 자리에 초대하고자 합니다. 이 미팅에서 귀하께서 가지고 계신 질문이나 우려 사항을 해결할 수 있습니다. 다음 주 가능한 시간을 알려주시기 바랍니다.

저희의 제안을 고려해 주셔서 감사합니다. 귀하를 환영하고 함께 큰 성공을 이루기 위해 협력하기를 기대합니다.

감사합니다,

조던 박

인사 관리자

노바브릿지 솔루션즈`,

  koreanNouns: `Dear Hannah Lee,

We are thrilled to inform you that you have been selected for the position of Marketing Specialist at NovaBridge Solutions. Our team was <mark>매우</mark> impressed with your qualifications and experience, and we are confident that you will be a valuable addition to our organization.

Please find below the details of the offer:

- Position: Marketing Specialist
- Salary: $68,000 per year + performance-based bonus
- Start Date: September 4, 2055
- Location: 1200 Grand Avenue, Suite 402, San Francisco, CA

We would like to invite you to a <mark>미팅</mark> to discuss the details of your employment <mark>대면으로</mark>. During this meeting, we can <mark>다루다</mark> any questions or concerns you might have. Please let us know your availability for the upcoming week.

Thank you for considering our offer. We are eager to <mark>환영하는것 당신을 우리팀에</mark> and look forward to working together to achieve great success.

Best Regards,

Jordan Park
HR Manager
NovaBridge Solutions`,

  wordPairs: {
    highly: "매우",
    meeting: "미팅",
    "in person": "대면으로",
    address: "다루다",
    "welcome you aboard": "환영하는것 당신을 우리팀에",
  },

  questions: [],
};
const email7 = {
  id: 7,
  passage: `Dear Mr. Williams,

I am writing to formally request vacation <mark>leave</mark> from December 5, 2050, to December 10, 2050, in order to attend a business trip that is <mark>crucial</mark> for the growth of our team. During this trip, I will be meeting with <mark>key</mark> partners and clients to finalize agreements and discuss upcoming projects.

Given the importance of this trip, I believe my <mark>presence</mark> will be essential in achieving our goals, and I would like to ensure that everything is well-prepared before my departure.

I will make sure all my tasks are <mark>up to date</mark> before leaving, and I will be available <mark>remotely</mark> should any urgent matters <mark>arise</mark> during my absence. I also plan to <mark>delegate</mark> responsibilities to my team, ensuring that there is no <mark>disruption</mark> in <mark>ongoing</mark> projects while I am away.

Please let me know if you need any additional details to process this request.

Kind regards,

Sophia Chen
Sales Director
sophia.chen@oriontech.com`,

  translation: `윌리엄스 님께,

저희 팀의 성장에 중요한 출장에 참석하기 위해 2050년 12월 5일부터 2050년 12월 10일까지 휴가를 공식적으로 요청드립니다. 이 출장 기간 동안, 저는 주요 파트너 및 고객들과 만나 계약을 마무리하고 향후 프로젝트에 대해 논의할 예정입니다.

이 출장의 중요성을 고려할 때, 저의 참석이 우리의 목표 달성에 필수적이라고 생각하며, 출발 전에 모든 준비가 잘 되어 있는지 확인하고 싶습니다.

떠나기 전에 모든 업무를 최신 상태로 유지할 것이며, 제가 없는 동안 긴급한 문제가 발생할 경우 원격으로 연락 가능합니다. 또한 제가 자리를 비우는 동안 진행 중인 프로젝트에 차질이 없도록 팀원들에게 책임을 위임할 계획입니다.

이 요청을 처리하기 위해 추가 정보가 필요하시면 알려주시기 바랍니다.

감사합니다,

소피아 첸
영업 이사
sophia.chen@oriontech.com`,

  koreanNouns: `Dear Mr. Williams,

I am writing to formally request vacation <mark>휴가</mark> from December 5, 2050, to December 10, 2050, in order to attend a business trip that is <mark>중요한</mark> for the growth of our team. During this trip, I will be meeting with <mark>주요</mark> partners and clients to finalize agreements and discuss upcoming projects.

Given the importance of this trip, I believe my <mark>참석</mark> will be essential in achieving our goals, and I would like to ensure that everything is well-prepared before my departure.

I will make sure all my tasks are <mark>최신 상태로</mark> before leaving, and I will be available <mark>원격으로</mark> should any urgent matters <mark>발생하다</mark> during my absence. I also plan to <mark>위임하다</mark> responsibilities to my team, ensuring that there is no <mark>차질</mark> in <mark>진행 중인</mark> projects while I am away.

Please let me know if you need any additional details to process this request.

Kind regards,

Sophia Chen
Sales Director
sophia.chen@oriontech.com`,

  wordPairs: {
    leave: "휴가",
    crucial: "중요한",
    key: "주요",
    presence: "참석",
    "up to date": "최신 상태로",
    remotely: "원격으로",
    arise: "발생하다",
    delegate: "위임하다",
    disruption: "차질",
    ongoing: "진행 중인",
  },

  questions: [],
};
const email8 = {
  id: 8,
  passage: `Dear Jessica Martin,

Please accept my <mark>resignation</mark> from the position of Marketing Manager of BlueNova Solutions. My resignation is effective <mark>as of today</mark> March 22, 2025. As per current policy, my last working date will be April 5, 2025.

I am very thankful for the opportunities which BlueNova Solutions provided me. It has been an <mark>enriching</mark> and <mark>rewarding</mark> experience. <mark>Having said that</mark>, it's time for me to move on to <mark>pursue</mark> new challenges.

I will be happy to <mark>hand over</mark> my responsibilities at the earliest.

I wish BlueNova Solutions great success in the coming years!!

Regards,

Liam Reynolds`,

  translation: `제시카 마틴님께,

블루노바 솔루션의 마케팅 매니저 직책에서 사직서를 제출합니다. 사직은 오늘 2025년 3월 22일부터 유효합니다. 현재 정책에 따라, 제 마지막 근무일은 2025년 4월 5일이 될 것입니다.

블루노바 솔루션이 제공해 준 기회에 매우 감사드립니다. 이곳에서의 경험은 풍부하고 보람찼습니다. 그렇지만, 이제는 새로운 도전을 위해 떠날 시간이 되었습니다.

가능한 빨리 제 업무를 인계하겠습니다.

앞으로 블루노바 솔루션의 큰 성공을 기원합니다!!

감사합니다,

리암 레이놀즈`,

  koreanNouns: `Dear Jessica Martin,

Please accept my <mark>사직</mark> from the position of Marketing Manager of BlueNova Solutions. My resignation is effective <mark>오늘부터</mark> March 22, 2025. As per current policy, my last working date will be April 5, 2025.

I am very thankful for the opportunities which BlueNova Solutions provided me. It has been an <mark>풍부한</mark> and <mark>보람찬</mark> experience. <mark>그렇지만</mark>, it's time for me to move on to <mark>추구하다</mark> new challenges.

I will be happy to <mark>인계하다</mark> my responsibilities at the earliest.

I wish BlueNova Solutions great success in the coming years!!

Regards,

Liam Reynolds`,

  wordPairs: {
    resignation: "사직",
    "as of today": "오늘부터",
    enriching: "풍부한",
    rewarding: "보람찬",
    "Having said that": "그렇지만",
    pursue: "추구하다",
    "hand over": "인계하다",
  },

  questions: [],
};
const email9 = {
  id: 9,
  passage: `Dear Virginia Auer,

This letter serves as <mark>employment verification</mark> for Erica Price, who has been an <mark>integral</mark> part of our team here at NexaBridge Solutions since March 2045.

Erica Price currently holds the position of Project Manager in our Marketing Department, where she <mark>consistently</mark> demonstrates high-level organizational skills, a <mark>deep</mark> commitment to our clients, and an impressive ability to lead cross-functional teams toward successful project completion.

In her role, she oversees complex project workflows, coordinates team efforts, and ensures that all <mark>deliverables</mark> meet our <mark>rigorous</mark> quality standards.

<mark>Throughout</mark> her <mark>tenure</mark>, Erica Price has maintained an excellent performance record, <mark>exemplifying</mark> professionalism and <mark>adaptability</mark> in a fast-paced environment. Her responsibilities include strategic planning, client relations, and supervising project progress to meet both internal and client-specific goals.

Her work ethic and collaborative <mark>nature</mark> make her an asset to our company and a valued team member whose contributions significantly impact our organization's success.

If you require additional information regarding Erica Price's employment, please feel free to reach out to me directly at laura.mendez@nexabridge.com. We are happy to support Erica Price and verify her excellent standing within our organization.

Sincerely,

Laura Mendez

HR Director

NexaBridge Solutions`,

  translation: `Virginia Auer님께,

이 편지는 2045년 3월부터 NexaBridge Solutions의 팀원으로서 중요한 역할을 해온 Erica Price의 고용 확인서입니다.

Erica Price는 현재 마케팅 부서의 프로젝트 매니저 직책을 맡고 있으며, 높은 수준의 조직 능력, 고객에 대한 깊은 헌신, 그리고 프로젝트 성공적 완수를 위해 다기능 팀을 이끄는 인상적인 능력을 지속적으로 보여주고 있습니다.

그녀의 역할에서, 그녀는 복잡한 프로젝트 워크플로우를 감독하고, 팀 노력을 조율하며, 모든 결과물이 우리의 엄격한 품질 기준을 충족하도록 보장합니다.

재직 기간 동안, Erica Price는 빠르게 변화하는 환경에서 전문성과 적응력을 보여주며 우수한 성과 기록을 유지해왔습니다. 그녀의 책임에는 전략적 계획, 고객 관계, 그리고 내부 및 고객별 목표를 충족하기 위한 프로젝트 진행 감독이 포함됩니다.

그녀의 직업 윤리와 협력적인 성격은 그녀를 우리 회사의 자산이자 조직의 성공에 중요한 영향을 미치는 가치 있는 팀원으로 만듭니다.

Erica Price의 고용에 관한 추가 정보가 필요하시면, laura.mendez@nexabridge.com으로 직접 연락해 주십시오. 우리는 Erica Price를 지원하고 우리 조직 내에서 그녀의 우수한 위치를 확인하게 되어 기쁩니다.

감사합니다,

Laura Mendez

인사 디렉터

NexaBridge Solutions`,

  koreanNouns: `Dear Virginia Auer,

This letter serves as <mark>고용 확인서</mark> for Erica Price, who has been an <mark>중요한</mark> part of our team here at NexaBridge Solutions since March 2045.

Erica Price currently holds the position of Project Manager in our Marketing Department, where she <mark>지속적으로</mark> demonstrates high-level organizational skills, a <mark>깊은</mark> commitment to our clients, and an impressive ability to lead cross-functional teams toward successful project completion.

In her role, she oversees complex project workflows, coordinates team efforts, and ensures that all <mark>결과물</mark> meet our <mark>엄격한</mark> quality standards.

<mark>동안</mark> her <mark>재직 기간</mark>, Erica Price has maintained an excellent performance record, <mark>보여주며</mark> professionalism and <mark>적응력</mark> in a fast-paced environment. Her responsibilities include strategic planning, client relations, and supervising project progress to meet both internal and client-specific goals.

Her work ethic and collaborative <mark>성격</mark> make her an asset to our company and a valued team member whose contributions significantly impact our organization's success.

If you require additional information regarding Erica Price's employment, please feel free to reach out to me directly at laura.mendez@nexabridge.com. We are happy to support Erica Price and verify her excellent standing within our organization.

Sincerely,

Laura Mendez

HR Director

NexaBridge Solutions`,

  wordPairs: {
    "employment verification": "고용 확인서",
    integral: "중요한",
    consistently: "지속적으로",
    deep: "깊은",
    deliverables: "결과물",
    rigorous: "엄격한",
    Throughout: "동안",
    tenure: "재직 기간",
    exemplifying: "보여주며",
    adaptability: "적응력",
    nature: "성격",
  },

  questions: [],
};
const email10 = {
  id: 10,
  passage: `Dear Ms. Tate,

I am writing to express my interest in the position of Senior Project Manager, advertised on your company's <mark>careers</mark> page. With over a decade of experience in leading cross-functional teams and delivering complex projects within deadline and <mark>budget constraints</mark>, I am excited about the opportunity to contribute to LifeWhiz's mission of driving innovation.

In my previous role as Project Manager, I successfully led a team of 15 professionals across multiple departments and was responsible for the completion of a $10 million project that enhanced operational <mark>efficiency</mark> by 30%. My ability to communicate effectively with <mark>stakeholders</mark> and my <mark>knack</mark> for efficient resource allocation were <mark>pivotal</mark> to the project's success.

I am particularly drawn to this opportunity at LifeWhiz as it aligns with my passion for integrating sustainable practices into project management. I admire your company's commitment to <mark>sustainability</mark> and its proactive approach to reducing environmental impact. I am eager to bring my expertise in green project management to your esteemed organization.

I have attached my resume for your consideration and would welcome the opportunity to discuss how I can contribute to the continued success and growth of LifeWhiz. Thank you for considering my application. I look forward to the possibility of discussing this exciting opportunity with you.

Thank you for your time and consideration.

Sincerely,

Daniel Kim`,
  translation: `Tate 님께,

귀사의 채용 페이지에 게시된 시니어 프로젝트 매니저 직책에 지원하고자 이 편지를 씁니다. 10년 이상의 다기능 팀 리딩 경험과 기한 및 예산 제약 내에서 복잡한 프로젝트를 수행한 경험을 바탕으로, LifeWhiz의 혁신 추진 미션에 기여할 기회에 대해 기대하고 있습니다.

이전 프로젝트 매니저 역할에서 저는 여러 부서에 걸쳐 15명의 전문가로 구성된 팀을 성공적으로 이끌었으며, 운영 효율성을 30% 향상시킨 1천만 달러 규모의 프로젝트 완료를 담당했습니다. 이해관계자들과의 효과적인 의사소통 능력과 효율적인 자원 할당에 대한 재능이 프로젝트의 성공에 중요한 역할을 했습니다.

저는 특히 프로젝트 관리에 지속 가능한 관행을 통합하는 저의 열정과 일치하기 때문에 LifeWhiz에서의 이 기회에 끌립니다. 저는 귀사의 지속 가능성에 대한 헌신과 환경 영향을 줄이기 위한 적극적인 접근 방식을 존경합니다. 저는 귀하의 존경받는 조직에 친환경 프로젝트 관리에 대한 저의 전문 지식을 가져오고 싶습니다.

검토를 위해 제 이력서를 첨부했으며 LifeWhiz의 지속적인 성공과 성장에 어떻게 기여할 수 있는지 논의할 기회를 환영합니다. 제 지원을 고려해 주셔서 감사합니다. 이 흥미로운 기회에 대해 논의할 가능성을 기대합니다.

시간과 고려에 감사드립니다.

감사합니다,

Daniel Kim`,
  koreanNouns: `Dear Ms. Tate,

I am writing to express my interest in the position of Senior Project Manager, advertised on your company's <mark>채용</mark> page. With over a decade of experience in leading cross-functional teams and delivering complex projects within deadline and <mark>예산 제약</mark>, I am excited about the opportunity to contribute to LifeWhiz's mission of driving innovation.

In my previous role as Project Manager, I successfully led a team of 15 professionals across multiple departments and was responsible for the completion of a $10 million project that enhanced operational <mark>효율성</mark> by 30%. My ability to communicate effectively with <mark>이해관계자들</mark> and my <mark>재능</mark> for efficient resource allocation were <mark>중요한</mark> to the project's success.

I am particularly drawn to this opportunity at LifeWhiz as it aligns with my passion for integrating sustainable practices into project management. I admire your company's commitment to <mark>지속 가능성</mark> and its proactive approach to reducing environmental impact. I am eager to bring my expertise in green project management to your esteemed organization.

I have attached my resume for your consideration and would welcome the opportunity to discuss how I can contribute to the continued success and growth of LifeWhiz. Thank you for considering my application. I look forward to the possibility of discussing this exciting opportunity with you.

Thank you for your time and consideration.

Sincerely,

Daniel Kim`,
  wordPairs: {
    careers: "채용",
    "budget constraints": "예산 제약",
    efficiency: "효율성",
    stakeholders: "이해관계자들",
    knack: "재능",
    pivotal: "중요한",
    sustainability: "지속 가능성",
  },
  questions: [],
};

const email11 = {
  id: 1,
  passage: `From: Richard Daniels, HR Manager
To: All Employees
Subject: Updated Remote Work Policy
Date: March 5, 2025

Dear Team,

I hope this email finds you well. I am writing to inform you about an important update regarding our remote work policy, which will take effect starting April 1, 2025.

As part of our continuous efforts to improve work-life balance and enhance productivity, we have <mark>revised</mark> the current remote work guidelines. Below are the key updates:

- Hybrid Work Model : Employees may work up to three days per week <mark>remotely</mark>, with at least two days required in the office.
- Approval Process: Remote work request must be submitted at least 48 hours in advance and approved by supervisor.
- Availability Requirements: All remote employee must remain <mark>reachable</mark> during working hours and attend scheduled meetings as required.
- Security & Compliance : Employees must use company-approved devices and VPN connections to access internal systems.
- Please review the attached Remote Work Policy Handbook for <mark>complete</mark> details. Should you have any questions or require further clarification, feel free to contact the HR department at hr@glowtech.com.

We appreciate your cooperation and commitment to maintaining a flexible and productive work environment.

Sincerely,
Richard Daniels
HR Manager
GlowTech Inc.`,

  translation: `보내는 사람: Richard Daniels, 인사팀장
받는 사람: 전 직원
제목: 재택근무 정책 업데이트 
날짜: 2025년 3월 5일

직원 여러분,

안녕하십니까. 2025년 4월 1일부터 시행될 재택근무 정책의 중요한 변경사항을 안내드리고자 합니다.

당사는 임직원들의 워라밸 향상과 업무 생산성 제고를 위해 현행 재택근무 지침을 개정하였습니다. 주요 변경사항은 다음과 같습니다:

하이브리드 근무제: 직원들은 주당 최대 3일까지 재택근무가 가능하며, 최소 2일은 사무실 출근이 필요합니다.
승인 절차: 재택근무 신청은 최소 48시간 전에 제출되어야 하며 직속 상사의 승인이 필요합니다.
근무 가능 요건: 모든 재택근무자는 정규 근무시간 동안 연락 가능한 상태를 유지해야 하며, 예정된 회의에 필요한 대로 참석해야 합니다.
보안 및 규정 준수: 직원들은 내부 시스템 접속 시 회사가 승인한 기기와 VPN 연결을 사용해야 합니다.
자세한 내용은 첨부된 재택근무 정책 안내서를 검토해 주시기 바랍니다. 문의사항이나 추가 설명이 필요하신 경우 인사부(hr@glowtech.com)로 연락 주시기 바랍니다.

유연하고 생산적인 근무 환경 유지를 위한 여러분의 협조와 노력에 감사드립니다.

감사합니다.
Richard Daniels
인사팀장
GlowTech Inc.`,
  koreanNouns: `From: Richard Daniels, HR Manager
To: All Employees
Subject: Updated Remote Work Policy
Date: March 5, 2025

Dear Team,

I hope this email finds you well. I am writing to inform you about an important update regarding our remote work policy, which will take effect starting April 1, 2025.

As part of our continuous efforts to improve work-life balance and enhance productivity, we have <mark>개정된</mark> the current remote work guidelines. Below are the key updates:

- Hybrid Work Model : Employees may work up to three days per week <mark>원격으로</mark>, with at least two days required in the office.
- Approval Process: Remote work request must be submitted at least 48 hours in advance and approved by supervisor.
- Availability Requirements: All remote employee must remain <mark>연락 가능한</mark> during working hours and attend scheduled meetings as required.
- Security & Compliance : Employees must use company-approved devices and VPN connections to access internal systems.
- Please review the attached Remote Work Policy Handbook for <mark>자세한</mark> details. Should you have any questions or require further clarification, feel free to contact the HR department at hr@glowtech.com.

We appreciate your cooperation and commitment to maintaining a flexible and productive work environment.

Sincerely,
Richard Daniels
HR Manager
GlowTech Inc.`,

  wordPairs: {
    revised: "개정된",
    remotely: "원격으로",
    reachable: "연락 가능한",
    complete: "자세한",
  },
};

const email12 = {
  id: 4,
  passage: `Subject: New Employee Onboarding Policy

Dear Team,

Effective from March 1, we will be <mark>implementing</mark> a new onboarding policy for all newly hired employees. Under this policy, new employees will be required to complete a three-week training program before <mark>assuming</mark> their regular duties.

The training sessions will cover company policies, workplace safety, and department-specific procedures. Attendance is mandatory, and managers are expected to ensure that new hires complete the program. A detailed schedule and training materials will be distributed next week.

If you have any questions regarding this change, please contact HR at hr@company.com. We appreciate your cooperation in making this transition smooth.

Best regards,
James Peterson
Human Resources Manager`,

  translation: `제목: 신입 직원 온보딩 정책

팀원 여러분,

3월 1일부터 모든 신규 채용 직원들을 위한 새로운 온보딩 정책이 시행될 예정입니다. 이 정책에 따라, 신입 직원들은 정규 업무를 시작하기 전에 3주간의 교육 프로그램을 이수해야 합니다.

교육 세션은 회사 정책, 직장 안전, 그리고 부서별 절차를 다룰 예정입니다. 출석은 필수이며, 관리자들은 신입 직원들이 프로그램을 완료하도록 확인해야 합니다. 자세한 일정과 교육 자료는 다음 주에 배포될 예정입니다.

이 변경사항에 대해 질문이 있으시면 인사팀(hr@company.com)으로 문의해 주시기 바랍니다. 원활한 전환을 위한 여러분의 협조에 감사드립니다.

감사합니다.
James Peterson
인사 관리자`,
  koreanNouns: `Subject: New Employee Onboarding Policy

Dear Team,

Effective from March 1, we will be <mark>시행될</mark> a new onboarding policy for all newly hired employees. Under this policy, new employees will be required to complete a three-week training program before <mark>시작하기</mark> their regular duties.

The training sessions will cover company policies, workplace safety, and department-specific procedures. Attendance is mandatory, and managers are expected to ensure that new hires complete the program. A detailed schedule and training materials will be distributed next week.

If you have any questions regarding this change, please contact HR at hr@company.com. We appreciate your cooperation in making this transition smooth.

Best regards,
James Peterson
Human Resources Manager`,

  wordPairs: {
    implementing: "시행될",
    assuming: "시작하기",
  },

  questions: [],
};

const email13 = {
  id: 13,
  passage: `Subject: Interview Invitation - Marketing Associate Position

Dear Ms. Olivia Chen,

We are pleased to inform you that your <mark>application</mark> for the Marketing Associate position at Horizon Solutions has been <mark>shortlisted</mark>. After a thorough review of your qualifications and experience, we would like to invite you to an interview as part of our selection process.

Interview Details:
- Date: March 12, 2025
- Time: 10:00 AM – 11:00 AM
- Location: Horizon Solutions Headquarters, 5th Floor, 123 Greenway Avenue, New York, NY
- Format: In-person (Virtual option available upon request)

During the interview, you will meet with the Hiring Manager and Senior Marketing Team, and we will discuss your qualifications, professional experience, and suitability for the role. Additionally, you may be asked to complete a brief skills assessment relevant to the position.

Please confirm your availability for the scheduled interview by replying to this email no later than March 8, 2025. If you require any adjustments or <mark>accommodations</mark>, do not hesitate to inform us in advance.

We appreciate your interest in joining Horizon Solutions, and we look forward to speaking with you soon.

Best regards,
Daniel Roberts
HR Coordinator
Horizon Solutions`,

  translation: `제목: 면접 초대 - 마케팅 담당자 직책

올리비아 첸 님께,

호라이즌 솔루션즈의 마케팅 담당자 직책에 지원해 주셔서 감사합니다. 귀하의 자격과 경력을 면밀히 검토한 결과, 채용 과정의 일환으로 면접에 초대하고자 합니다.

면접 세부사항:
날짜: 2025년 3월 12일
시간: 오전 10:00 – 오전 11:00
장소: 호라이즌 솔루션즈 본사, 5층, 123 그린웨이 애비뉴, 뉴욕, 뉴욕 주
형식: 대면 면접 (요청 시 화상 면접 가능)

면접에서는 채용 담당자와 시니어 마케팅 팀을 만나 귀하의 자격, 직무 경험, 그리고 해당 직책에 대한 적합성을 논의할 예정입니다. 또한 직무와 관련된 간단한 실무 평가가 있을 수 있습니다.

2025년 3월 8일까지 이메일로 면접 일정 참석 가능 여부를 알려주시기 바랍니다. 특별한 조정이나 편의가 필요하신 경우 미리 알려주시기 바랍니다.

호라이즌 솔루션즈에 관심을 가져주셔서 감사드리며, 곧 만나 뵙기를 기대합니다.

감사합니다.
대니얼 로버츠
인사 코디네이터
호라이즌 솔루션즈`,
  koreanNouns: `Subject: Interview Invitation - Marketing Associate Position

Dear Ms. Olivia Chen,

We are pleased to inform you that your <mark>지원서</mark> for the Marketing Associate position at Horizon Solutions has been <mark>서류 합격된</mark>. After a thorough review of your qualifications and experience, we would like to invite you to an interview as part of our selection process.

Interview Details:
- Date: March 12, 2025
- Time: 10:00 AM – 11:00 AM
- Location: Horizon Solutions Headquarters, 5th Floor, 123 Greenway Avenue, New York, NY
- Format: In-person (Virtual option available upon request)

During the interview, you will meet with the Hiring Manager and Senior Marketing Team, and we will discuss your qualifications, professional experience, and suitability for the role. Additionally, you may be asked to complete a brief skills assessment relevant to the position.

Please confirm your availability for the scheduled interview by replying to this email no later than March 8, 2025. If you require any adjustments or <mark>편의 시설</mark>, do not hesitate to inform us in advance.

We appreciate your interest in joining Horizon Solutions, and we look forward to speaking with you soon.

Best regards,
Daniel Roberts
HR Coordinator
Horizon Solutions`,

  wordPairs: {
    application: "지원서",
    shortlisted: "서류 합격된",
    accommodations: "편의 시설",
  },
  questions: [],
};

const email14 = {
  id: 14,
  passage: `Subject: Job Opening – Marketing Coordinator Position

Dear Team,

We are excited to announce that Horizon Solutions is currently seeking a Marketing Coordinator to join our dynamic team. This is an excellent opportunity for a <mark>highly</mark> motivated individual with a passion for brand management, digital marketing, and market research.

Position Details:
- Job Title: Marketing Coordinator
- Location: Horizon Solutions <mark>Headquarters</mark>, New York, NY
- Employment Type: <mark>Full-time</mark>
- Salary: Competitive, based on experience
- Application Deadline: March 20, 2025

Key Responsibilities:
Develop and <mark>execute</mark> marketing campaigns to enhance brand visibility.
Conduct market research and analyze consumer trends.
Collaborate with cross-functional teams to create promotional materials.
Manage the company's social media presence and digital advertising efforts.
Monitor and report on campaign performance metrics.

Qualifications & Requirements:
✔ <mark>Bachelor's degree</mark> in Marketing, Business Administration, or a related field.
✔ Minimum of 2 years of experience in marketing or advertising.
✔ <mark>Proficiency</mark> in digital marketing tools and analytics platforms.
✔ Strong communication and organizational skills.
✔ Ability to work in a <mark>fast-paced</mark> environment and meet deadlines.

How to Apply:
Interested candidates are encouraged to submit their resume and cover letter to hr@horizoncompany.com by March 20, 2025. Shortlisted applicants will be contacted for further interviews.

For any questions regarding this position, please reach out to Daniel Roberts (HR Director) at hr@horizoncompany.com.

We look forward to welcoming a <mark>talented</mark> new team member to Horizon Solutions!

Best regards,
Daniel Roberts
HR Director
Horizon Solutions`,

  translation: `제목: 채용 공고 - 마케팅 코디네이터 직책

팀원 여러분께,

호라이즌 솔루션즈에서 역동적인 팀에 합류할 마케팅 코디네이터를 모집하고 있음을 기쁘게 알려드립니다. 이는 브랜드 관리, 디지털 마케팅, 시장 조사에 열정을 가진 의욕 넘치는 인재에게 좋은 기회가 될 것입니다.

직책 세부사항:
- 직책명: 마케팅 코디네이터
- 근무지: 호라이즌 솔루션즈 본사, 뉴욕, 뉴욕 주
- 고용형태: 정규직
- 급여: 경력에 따른 경쟁력 있는 급여
- 지원마감: 2025년 3월 20일

주요 업무:
브랜드 가시성 향상을 위한 마케팅 캠페인 개발 및 실행
시장 조사 및 소비자 트렌드 분석
홍보 자료 제작을 위한 부서 간 협업
회사 소셜 미디어 관리 및 디지털 광고 활동
캠페인 성과 지표 모니터링 및 보고

자격요건 및 필수사항:
✔ 마케팅, 경영학 또는 관련 분야 학사 학위
✔ 마케팅 또는 광고 분야 2년 이상 경력
✔ 디지털 마케팅 도구 및 분석 플랫폼 능숙도
✔ 뛰어난 의사소통 및 조직력
✔ 빠른 업무 환경에서 일하며 기한 준수 능력

지원 방법:
관심 있는 지원자는 2025년 3월 20일까지 이력서와 자기소개서를 hr@horizoncompany.com으로 제출해 주시기 바랍니다. 선발된 지원자에 한해 추가 면접을 진행할 예정입니다.

해당 직책에 대한 문의사항은 대니얼 로버츠(인사 디렉터)에게 hr@horizoncompany.com으로 연락 주시기 바랍니다.

호라이즌 솔루션즈에서 재능 있는 새 팀원을 맞이하기를 기대합니다!

감사합니다.
대니얼 로버츠
인사 디렉터
호라이즌 솔루션즈`,

  koreanNouns: `Subject: Job Opening – Marketing Coordinator Position

Dear Team,

We are excited to announce that Horizon Solutions is currently seeking a Marketing Coordinator to join our dynamic team. This is an excellent opportunity for a <mark>매우</mark> motivated individual with a passion for brand management, digital marketing, and market research.

Position Details:
- Job Title: Marketing Coordinator
- Location: Horizon Solutions <mark>본사</mark>, New York, NY
- Employment Type: <mark>정규직</mark>
- Salary: Competitive, based on experience
- Application Deadline: March 20, 2025

Key Responsibilities:
Develop and <mark>실행하다</mark> marketing campaigns to enhance brand visibility.
Conduct market research and analyze consumer trends.
Collaborate with cross-functional teams to create promotional materials.
Manage the company's social media presence and digital advertising efforts.
Monitor and report on campaign performance metrics.

Qualifications & Requirements:
✔ <mark>학사 학위</mark> in Marketing, Business Administration, or a related field.
✔ Minimum of 2 years of experience in marketing or advertising.
✔ <mark>능숙도</mark> in digital marketing tools and analytics platforms.
✔ Strong communication and organizational skills.
✔ Ability to work in a <mark>빠른 업무 환경</mark> environment and meet deadlines.

How to Apply:
Interested candidates are encouraged to submit their resume and cover letter to hr@horizoncompany.com by March 20, 2025. Shortlisted applicants will be contacted for further interviews.

For any questions regarding this position, please reach out to Daniel Roberts (HR Director) at hr@horizoncompany.com.

We look forward to welcoming a <mark>재능 있는</mark> new team member to Horizon Solutions!

Best regards,
Daniel Roberts
HR Director
Horizon Solutions`,

  wordPairs: {
    highly: "매우",
    "Full-time": "정규직",
    Headquarters: "본사",
    execute: "실행하다",
    "Bachelor's degree": "학사 학위",
    Proficiency: "능숙도",
    "fast-paced": "빠른 업무 환경",
    talented: "재능 있는",
  },

  questions: [],
};

const email15 = {
  id: 15,
  passage: `Subject: Job Offer & Onboarding Information – Marketing Coordinator Position

Dear Ms. Rachel Kim,

We are pleased to offer you the position of Marketing Coordinator at Horizon Solutions. After a <mark>thorough</mark> evaluation of your qualifications and interview performance, we are confident that your skills and experience will be a <mark>valuable</mark> addition to our team.

Offer Details:
- Position: Marketing Coordinator
- Location: Horizon Solutions Headquarters, New York, NY
- Employment Type: Full-time
- Salary: $60,000 per year
- Start Date: April 1, 2025

This offer is contingent upon the successful completion of the required pre-employment procedures, including a background check and submission of necessary employment documents.

Next Steps – <mark>Onboarding Process</mark>:
To facilitate a smooth transition, please review and complete the following steps:
✔ Sign and return the offer letter by March 10, 2025.
✔ Submit employment documents (proof of identity, tax forms, and direct deposit information).
✔ Attend the New Hire Orientation scheduled for April 2, 2025, where you will receive details on company policies, benefits, and your initial training schedule.

If you have any questions regarding the terms of employment, benefits, or onboarding procedures, please do not hesitate to contact HR@horizoncompany.com.

We are excited to welcome you to Horizon Solutions and look forward to your contributions!

Best regards,
Daniel Roberts
HR Director
Horizon Solutions`,

  translation: `제목: 채용 제안 및 입사 안내 - 마케팅 코디네이터 직책

레이첼 김 님께,

호라이즌 솔루션즈의 마케팅 코디네이터 직책을 제안드리게 되어 기쁩니다. 귀하의 자격요건과 면접 수행 능력을 철저히 평가한 결과, 귀하의 능력과 경험이 우리 팀에 가치 있는 자산이 될 것이라 확신합니다.

채용 상세 내용:
- 직책: 마케팅 코디네이터
- 근무지: 호라이즌 솔루션즈 본사, 뉴욕
- 고용 형태: 정규직
- 연봉: $60,000
- 입사일: 2025년 4월 1일

이 채용 제안은 신원 조회와 필요한 고용 서류 제출을 포함한 채용 전 필수 절차의 성공적인 완료를 전제로 합니다.

다음 단계 - 입사 절차:
원활한 전환을 위해 다음 단계를 검토하고 완료해 주시기 바랍니다:
✔ 2025년 3월 10일까지 채용 제안서 서명 및 회신
✔ 고용 서류 제출 (신분증, 세금 양식, 계좌이체 정보)
✔ 2025년 4월 2일 예정된 신입 사원 오리엔테이션 참석 (회사 정책, 복리후생, 초기 교육 일정에 대한 상세 내용 안내 예정)

고용 조건, 복리후생 또는 입사 절차에 대해 문의사항이 있으시면 언제든 HR@horizoncompany.com으로 연락 주시기 바랍니다.

호라이즌 솔루션즈에 오신 것을 환영하며, 귀하의 기여를 기대합니다!

감사합니다.
대니얼 로버츠
인사 디렉터
호라이즌 솔루션즈`,

  koreanNouns: `Subject: Job Offer & Onboarding Information – Marketing Coordinator Position

Dear Ms. Rachel Kim,

We are pleased to offer you the position of Marketing Coordinator at Horizon Solutions. After a <mark>철저한</mark> evaluation of your qualifications and interview performance, we are confident that your skills and experience will be a <mark>가치 있는</mark> addition to our team.

Offer Details:
- Position: Marketing Coordinator
- Location: Horizon Solutions Headquarters, New York, NY
- Employment Type: Full-time
- Salary: $60,000 per year
- Start Date: April 1, 2025

This offer is contingent upon the successful completion of the required pre-employment procedures, including a background check and submission of necessary employment documents.

Next Steps – <mark>입사 절차</mark>:
To facilitate a smooth transition, please review and complete the following steps:
✔ Sign and return the offer letter by March 10, 2025.
✔ Submit employment documents (proof of identity, tax forms, and direct deposit information).
✔ Attend the New Hire Orientation scheduled for April 2, 2025, where you will receive details on company policies, benefits, and your initial training schedule.

If you have any questions regarding the terms of employment, benefits, or onboarding procedures, please do not hesitate to contact HR@horizoncompany.com.

We are excited to welcome you to Horizon Solutions and look forward to your contributions!

Best regards,
Daniel Roberts
HR Director
Horizon Solutions`,

  wordPairs: {
    thorough: "철저한",
    valuable: "가치 있는",
    "Onboarding Process": "입사 절차",
  },

  questions: [],
};

const email16 = {
  id: 16,
  passage: `Subject: Important Information Regarding Your Severance Pay & Retirement Plan

Dear Mr. Thomas Bennett,

We would like to provide you with detailed information regarding your <mark>severance package</mark> and retirement plan options as you prepare for your departure from Horizon Solutions. We appreciate your dedicated service and wish to ensure a smooth transition into the next phase of your career.

Severance Pay Details:
- <mark>Eligibility</mark>: Employees with a tenure of three years or more
- Severance Payment: Based on years of service and final salary
- Payout Schedule: <mark>Lump sum</mark> payment will be processed within 30 days of your final working day
- Tax Implications: Severance pay may <mark>be subject to</mark> income tax deductions <mark>in accordance with</mark> federal and state regulations

If you have any questions regarding the calculation of your severance package, please reach out to HR@horizoncompany.com.

Retirement Plan Options:
As a <mark>departing</mark> employee, you have several options regarding your 401(k) retirement plan:
✔ Rollover to an IRA or another employer-sponsored plan to maintain tax-deferred status
✔ Withdraw funds, which may be subject to early withdrawal penalties and income tax
✔ Leave your account with Horizon Solutions if the balance exceeds the required minimum

To initiate any changes to your retirement savings account, please contact our Financial Benefits Team at benefits@horizoncompany.com no later than April 15, 2025.

Next Steps:
You will receive a final <mark>paycheck</mark>, including any accrued but unused paid time off (PTO).
Your health insurance coverage will remain active through the end of the month, after which you may be eligible for COBRA continuation coverage.
You may schedule a one-on-one consultation with an HR representative to discuss your severance and retirement options in detail.

We thank you for your contributions to Horizon Solutions and wish you success in your future endeavors. If you need further assistance, do not hesitate to contact us.

Best regards,
Daniel Roberts
HR Director
Horizon Solutions`,

  translation: `제목: 퇴직금 및 퇴직연금 관련 중요 안내

토마스 베넷 님께,

호라이즌 솔루션즈에서의 퇴사를 준비하시는 과정에서 퇴직금 패키지와 퇴직연금 플랜 옵션에 대한 상세 정보를 안내해 드리고자 합니다. 그동안의 헌신적인 근무에 감사드리며, 새로운 경력으로의 원활한 전환을 지원하고자 합니다.

퇴직금 상세 내용:
- 자격 요건: 3년 이상 근속 직원
- 퇴직금: 근속 연수와 최종 급여를 기준으로 산정
- 지급 일정: 최종 근무일로부터 30일 이내 일시불 지급
- 세금 관련: 연방 및 주 규정에 따라 소득세가 공제될 수 있음

퇴직금 산정에 대해 문의사항이 있으시면 HR@horizoncompany.com으로 연락 주시기 바랍니다.

퇴직연금 플랜 옵션:
퇴사 직원으로서 401(k) 퇴직연금에 대해 다음과 같은 옵션이 있습니다:
✔ 세금 이연 상태를 유지하기 위해 IRA 또는 다른 고용주 후원 플랜으로 이전
✔ 자금 인출 (조기 인출 시 패널티 및 소득세 부과 가능)
✔ 잔액이 최소 요구 금액을 초과할 경우 호라이즌 솔루션즈에 계좌 유지

퇴직연금 계좌 변경을 원하시면 2025년 4월 15일까지 benefits@horizoncompany.com의 재무혜택팀으로 연락 주시기 바랍니다.

다음 단계:
미사용 유급휴가를 포함한 최종 급여를 지급받으실 예정입니다.
건강보험은 이번 달 말까지 유지되며, 이후 COBRA 연장 보험 가입 자격이 주어질 수 있습니다.
퇴직금과 퇴직연금 옵션에 대해 자세히 논의하기 위한 인사 담당자와의 1:1 상담을 예약하실 수 있습니다.

호라이즌 솔루션즈에 기여해 주신 점에 감사드리며, 앞으로의 발전을 기원합니다. 추가 도움이 필요하시면 언제든 연락 주시기 바랍니다.

감사합니다.
대니얼 로버츠
인사 디렉터
호라이즌 솔루션즈`,

  koreanNouns: `Subject: Important Information Regarding Your Severance Pay & Retirement Plan

Dear Mr. Thomas Bennett,

We would like to provide you with detailed information regarding your <mark>퇴직금 패키지</mark> and retirement plan options as you prepare for your departure from Horizon Solutions. We appreciate your dedicated service and wish to ensure a smooth transition into the next phase of your career.

Severance Pay Details:
- <mark>자격 요건</mark>: Employees with a tenure of three years or more
- Severance Payment: Based on years of service and final salary
- Payout Schedule: <mark>일시불</mark> payment will be processed within 30 days of your final working day
- Tax Implications: Severance pay may <mark>~의 대상이 되다</mark> income tax deductions <mark>에 따라</mark> federal and state regulations

If you have any questions regarding the calculation of your severance package, please reach out to HR@horizoncompany.com.

Retirement Plan Options:
As a <mark>떠나는</mark> employee, you have several options regarding your 401(k) retirement plan:
✔ Rollover to an IRA or another employer-sponsored plan to maintain tax-deferred status
✔ Withdraw funds, which may be subject to early withdrawal penalties and income tax
✔ Leave your account with Horizon Solutions if the balance exceeds the required minimum

To initiate any changes to your retirement savings account, please contact our Financial Benefits Team at benefits@horizoncompany.com no later than April 15, 2025.

Next Steps:
You will receive a final <mark>급여</mark>, including any accrued but unused paid time off (PTO).
Your health insurance coverage will remain active through the end of the month, after which you may be eligible for COBRA continuation coverage.
You may schedule a one-on-one consultation with an HR representative to discuss your severance and retirement options in detail.

We thank you for your contributions to Horizon Solutions and wish you success in your future endeavors. If you need further assistance, do not hesitate to contact us.

Best regards,
Daniel Roberts
HR Director
Horizon Solutions`,

  wordPairs: {
    "severance package": "퇴직금 패키지",
    Eligibility: "자격 요건",
    "Lump sum": "일시불",
    "in accordance with": "에 따라",
    departing: "떠나는",
    "be subject to": "~의 대상이 되다",
    paycheck: "급여",
  },

  questions: [],
};

const email17 = {
  id: 17,
  passage: `Subject: Important Update: Changes to Vacation & Leave Policy
Dear Team,

We would like to inform you of upcoming modifications to our Vacation & Leave Policy, effective April 1, 2025. These changes are designed to provide greater flexibility while ensuring smooth workforce management across all departments. Please review the key updates below.

Key Policy Updates

📌 Annual Leave Entitlement:

Employees with less than three years of service: 12 days of paid annual leave (previously 10 days).
Employees with three or more years of service: 15 days of paid annual leave (previously 12 days).

📌 Carryover Policy:
Unused vacation days may now be carried over to the following year, up to a maximum of five days.
Any unused days beyond this limit will expire at the end of the calendar year.

📌 Request & Approval Process:
All leave requests must be submitted via the HR portal at least two weeks in advance.
Leave approval <mark>is subject to</mark> business needs and team availability.
Emergency leave requests will be handled on a case-by-case basis.

📌 Sick Leave & Personal Days:
Employees are entitled to five additional paid sick days per year.
Personal leave requests must be discussed with direct supervisors prior to submission.
To ensure compliance with the updated policy, we encourage all employees to review the full Vacation & Leave Policy document available on the company's intranet portal. If you have any questions or require further clarification, please contact HR@horizoncompany.com.

We appreciate your cooperation in implementing these changes and thank you for your continued dedication to the company.

Best regards,
Daniel Roberts
HR Director
Horizon Solutions`,

  translation: `제목: 휴가 및 휴직 정책 변경에 관한 중요 안내
팀원 여러분께,

2025년 4월 1일부터 시행될 휴가 및 휴직 정책의 변경 사항을 안내해 드립니다. 이번 변경은 모든 부서의 원활한 인력 관리를 보장하면서 더 큰 유연성을 제공하기 위해 마련되었습니다. 아래의 주요 변경 사항을 검토해 주시기 바랍니다.

주요 정책 변경 사항

📌 연차 휴가 자격:
근속 3년 미만 직원: 12일의 유급 연차 휴가 (기존 10일)
근속 3년 이상 직원: 15일의 유급 연차 휴가 (기존 12일)

📌 이월 정책:
미사용 휴가일은 최대 5일까지 다음 연도로 이월 가능
이 한도를 초과하는 미사용 일수는 해당 연도 말에 소멸

📌 신청 및 승인 절차:
모든 휴가 신청은 최소 2주 전에 HR 포털을 통해 제출
휴가 승인은 업무상 필요와 팀 가용성에 따라 결정
긴급 휴가 신청은 개별 상황에 따라 처리

📌 병가 및 개인 휴가:
직원들은 연간 5일의 추가 유급 병가 사용 가능
개인 휴가 신청은 제출 전 직속 상사와 논의 필요
변경된 정책의 준수를 위해 모든 직원들은 회사 인트라넷 포털에서 제공되는 전체 휴가 및 휴직 정책 문서를 검토하시기 바랍니다. 문의사항이나 추가 설명이 필요하신 경우 HR@horizoncompany.com으로 연락 주시기 바랍니다.

이러한 변경 사항 시행에 협조해 주심에 감사드리며, 회사에 대한 지속적인 헌신에 감사드립니다.

감사합니다.
대니얼 로버츠
인사 디렉터
호라이즌 솔루션즈`,
  koreanNouns: `Subject: Important Update: Changes to Vacation & Leave Policy
Dear Team,

We would like to inform you of upcoming modifications to our Vacation & Leave Policy, effective April 1, 2025. These changes are designed to provide greater flexibility while ensuring smooth workforce management across all departments. Please review the key updates below.

Key Policy Updates

📌 Annual Leave Entitlement:

Employees with less than three years of service: 12 days of paid annual leave (previously 10 days).
Employees with three or more years of service: 15 days of paid annual leave (previously 12 days).

📌 Carryover Policy:
Unused vacation days may now be carried over to the following year, up to a maximum of five days.
Any unused days beyond this limit will expire at the end of the calendar year.

📌 Request & Approval Process:
All leave requests must be submitted via the HR portal at least two weeks in advance.
Leave approval <mark>is subject to</mark> business needs and team availability.
Emergency leave requests will be handled on a case-by-case basis.

📌 Sick Leave & Personal Days:
Employees are entitled to five additional paid sick days per year.
Personal leave requests must be discussed with direct supervisors prior to submission.
To ensure compliance with the updated policy, we encourage all employees to review the full Vacation & Leave Policy document available on the company's intranet portal. If you have any questions or require further clarification, please contact HR@horizoncompany.com.

We appreciate your cooperation in implementing these changes and thank you for your continued dedication to the company.

Best regards,
Daniel Roberts
HR Director
Horizon Solutions`,

  wordPairs: {
    "is subject to": "~에 따라 결정됩니다",
  },

  questions: [],
};

const email18 = {
  id: 18,
  passage: `Subject: Exit Interview & Feedback Request

Dear Michael Anderson,

I hope you are doing well.

As you prepare to transition from your role at BrightTech Solutions, we would like to take this opportunity to express our <mark>sincere</mark> appreciation for your valuable contributions to the company. Your dedicated efforts have had a significant impact on our team, and we truly wish you the best in your next endeavor.

To help us continuously improve our work environment and employee experience, we kindly request your honest feedback regarding your time with us. We have attached a short <mark>exit interview</mark> form, which includes questions about your overall experience, reasons for leaving, and any <mark>constructive</mark> suggestions you may have.

Your <mark>candid</mark> insights will be extremely valuable in shaping our workplace policies and ensuring a more supportive and productive environment for current and future employees.

If you are available, we would also appreciate the opportunity to schedule a brief exit interview at your earliest convenience. Please let us know a time that works best for you.

Thank you again for your hard work and dedication during your time with us. We <mark>genuinely</mark> appreciate your valuable input and wish you nothing but success moving forward.

Best regards,
Emily Carter
HR Manager
BrightTech Solutions`,

  translation: `제목: 퇴사 인터뷰 및 피드백 요청

마이클 앤더슨 님께,

안녕하십니까.

브라이트테크 솔루션즈에서의 역할을 마무리하시는 시점에, 회사에 대한 귀하의 소중한 기여에 진심으로 감사의 말씀을 전하고자 합니다. 귀하의 헌신적인 노력은 우리 팀에 중요한 영향을 미쳤으며, 앞으로의 새로운 도전에서도 최선의 결과가 있기를 진심으로 기원합니다.

업무 환경과 직원 경험을 지속적으로 개선하기 위해, 귀하의 근무 기간에 대한 솔직한 피드백을 부탁드립니다. 전반적인 경험, 퇴사 이유, 그리고 건설적인 제안 등에 관한 질문이 포함된 간단한 퇴사 인터뷰 양식을 첨부하였습니다.

귀하의 솔직한 의견은 직장 정책을 형성하고 현재와 미래의 직원들을 위한 더 지원적이고 생산적인 환경을 조성하는 데 매우 귀중한 자료가 될 것입니다.

가능하시다면, 편하신 시간에 간단한 퇴사 인터뷰를 진행할 기회를 갖고 싶습니다. 가장 적합한 시간을 알려주시기 바랍니다.

귀하의 근무 기간 동안의 열정과 헌신에 다시 한번 감사드립니다. 귀하의 소중한 의견에 진심으로 감사드리며, 앞으로의 모든 일에 성공이 함께하기를 기원합니다.

감사합니다.
에밀리 카터
인사 관리자
브라이트테크 솔루션즈`,

  koreanNouns: `Subject: Exit Interview & Feedback Request

Dear Michael Anderson,

I hope you are doing well.

As you prepare to transition from your role at BrightTech Solutions, we would like to take this opportunity to express our <mark>진심으로</mark> appreciation for your valuable contributions to the company. Your dedicated efforts have had a significant impact on our team, and we truly wish you the best in your next endeavor.

To help us continuously improve our work environment and employee experience, we kindly request your honest feedback regarding your time with us. We have attached a short <mark>퇴사 인터뷰</mark> form, which includes questions about your overall experience, reasons for leaving, and any <mark>건설적인</mark> suggestions you may have.

Your <mark>솔직한</mark> insights will be extremely valuable in shaping our workplace policies and ensuring a more supportive and productive environment for current and future employees.

If you are available, we would also appreciate the opportunity to schedule a brief exit interview at your earliest convenience. Please let us know a time that works best for you.

Thank you again for your hard work and dedication during your time with us. We <mark>진심으로</mark> appreciate your valuable input and wish you nothing but success moving forward.

Best regards,
Emily Carter
HR Manager
BrightTech Solutions`,

  wordPairs: {
    sincere: "진심으로",
    "exit interview": "퇴사 인터뷰",
    constructive: "건설적인",
    candid: "솔직한",
    genuinely: "진심으로",
  },

  questions: [],
};

const email19 = {
  id: 33,
  passage: `Subject: Request for a Letter of Recommendation

Dear Mark Reynolds,

I hope you are doing well.

I am reaching out to kindly request a formal letter of recommendation as I transition to my next career opportunity. During my time at Sterling Innovations, I had the <mark>privilege</mark> of working under your expert guidance, and I truly appreciate the <mark>valuable</mark> experience I gained as part of your team.

As I pursue a new role in project management, a strong and <mark>credible</mark> reference from you would be highly beneficial in demonstrating my professional skills, dedication, and ability to collaborate effectively. If possible, I would greatly appreciate a detailed letter highlighting my key contributions, work ethic, and any <mark>notable</mark> achievements during my tenure.

I understand your busy schedule, so I would be happy to provide any necessary details or a draft to assist you. If you are comfortable with this request, please let me know at your earliest convenience.

Thank you for your time and consideration. Your support would mean a great deal to me, and I sincerely appreciate your kind assistance.

Best regards,
Daniel Carter
Former Project Coordinator
Sterling Innovations`,

  translation: `제목: 추천서 요청

마크 레이놀즈님께,

안녕하세요.

다음 경력 기회로 전환하면서 공식 추천서를 요청드리고자 연락드립니다. 스털링 이노베이션에서 근무하는 동안 귀하의 전문적인 지도 아래 일할 수 있는 특권을 가졌으며, 귀하의 팀의 일원으로서 얻은 귀중한 경험에 진심으로 감사드립니다.

프로젝트 관리 분야의 새로운 역할을 추구하면서, 귀하의 강력하고 신뢰할 수 있는 추천서는 제 전문적인 기술, 헌신, 효과적인 협업 능력을 입증하는 데 매우 유익할 것입니다. 가능하다면, 제 주요 기여, 직업 윤리, 그리고 재직 기간 동안의 주목할 만한 성과를 강조하는 상세한 추천서를 작성해 주시면 대단히 감사하겠습니다.

귀하의 바쁜 일정을 이해하고 있으므로, 필요한 세부 정보나 초안을 제공하여 도움을 드릴 수 있습니다. 이 요청에 동의하신다면, 가능한 빨리 알려주시기 바랍니다.

시간과 고려에 감사드립니다. 귀하의 지원은 저에게 큰 의미가 있으며, 귀하의 친절한 도움에 진심으로 감사드립니다.

감사합니다.
다니엘 카터
전 프로젝트 코디네이터
스털링 이노베이션`,
  koreanNouns: `Subject: Request for a Letter of Recommendation

Dear Mark Reynolds,

I hope you are doing well.

I am reaching out to kindly request a formal letter of recommendation as I transition to my next career opportunity. During my time at Sterling Innovations, I had the <mark>특권</mark> of working under your expert guidance, and I truly appreciate the <mark>귀중한</mark> experience I gained as part of your team.

As I pursue a new role in project management, a strong and <mark>신뢰할 수 있는</mark> reference from you would be highly beneficial in demonstrating my professional skills, dedication, and ability to collaborate effectively. If possible, I would greatly appreciate a detailed letter highlighting my key contributions, work ethic, and any <mark>주목할 만한</mark> achievements during my tenure.

I understand your busy schedule, so I would be happy to provide any necessary details or a draft to assist you. If you are comfortable with this request, please let me know at your earliest convenience.

Thank you for your time and consideration. Your support would mean a great deal to me, and I sincerely appreciate your kind assistance.

Best regards,
Daniel Carter
Former Project Coordinator
Sterling Innovations`,

  wordPairs: {
    privilege: "특권",
    valuable: "귀중한",
    credible: "신뢰할 수 있는",
    notable: "주목할 만한",
  },

  questions: [],
};

export const hrEmailQuestions = [
  email1,
  email2,
  email3,
  email4,
  email5,
  email6,
  email7,
  email8,
  email9,
  email10,
  email11,
  email12,
  email13,
  email14,
  email15,
  email16,
  email17,
  email18,
  email19,
];
